export const identityAreas = [
  { name: 'Engineering', copy: 'Physics-based design, analysis, integration, and verification.' },
  { name: 'Software', copy: 'Purpose-built engineering and scientific tools.' },
  { name: 'Technology', copy: 'Advanced energy and physical systems.' },
  { name: 'Research', copy: 'Long-horizon technical development.' },
]

export const companyPillars = [
  { eyebrow: 'Aldapa / Technology', title: 'Physical technology', items: ['Microreactors', 'Nuclear batteries', 'Energy conversion', 'Radiation systems'], path: '/technology' },
  { eyebrow: 'Aldapa / Software', title: 'Scientific software', items: ['AldapaNuCore', 'NuSpectra', 'AML', 'NuMath'], path: '/software' },
  { eyebrow: 'Aldapa / Engineering', title: 'Integrated engineering', items: ['Nuclear', 'Mechanical', 'Electrical', 'Simulation', 'Systems'], path: '/engineering' },
]

export const workflow = [
  { name: 'Problem', detail: ['Context', 'Objectives', 'Constraints'] },
  { name: 'Requirements', detail: ['Functions', 'Interfaces', 'Measures'] },
  { name: 'Physics', detail: ['Fundamental models', 'Material behavior', 'Boundaries'] },
  { name: 'Model', detail: ['Abstraction', 'Parameters', 'Assumptions'] },
  { name: 'Design', detail: ['Architecture', 'Trade studies', 'Margins'] },
  { name: 'Simulate', detail: ['Numerical methods', 'Multiphysics', 'Uncertainty'] },
  { name: 'Prototype', detail: ['Hardware', 'Software', 'Integration'] },
  { name: 'Test', detail: ['Instrumentation', 'Procedure', 'Evidence'] },
  { name: 'Validate', detail: ['Benchmarking', 'Testing', 'Verification'] },
  { name: 'Iterate', detail: ['Learn', 'Refine', 'Advance'] },
]

export const principles = [
  { name: 'Physics first', copy: 'Begin with the physical behavior of the system rather than assumptions about the solution.' },
  { name: 'Systems thinking', copy: 'Treat interfaces, dependencies, and coupled behavior as part of the design.' },
  { name: 'Traceability', copy: 'Connect requirements, models, assumptions, analysis, and decisions.' },
  { name: 'Verification', copy: 'Results should be testable, reproducible, and defensible.' },
  { name: 'Modularity', copy: 'Build components and tools that can evolve without destabilizing the complete system.' },
  { name: 'Long-term thinking', copy: 'Optimize for durable technical capability rather than short-term presentation.' },
]

export const storyPhases = [
  { phase: 'Foundation', title: 'Engineering projects', copy: 'A foundation in practical technical problem-solving and multidisciplinary analysis.' },
  { phase: 'Software', title: 'Scientific tools', copy: 'Purpose-built software for simulation, measurement, and engineering workflows.' },
  { phase: 'Research', title: 'Advanced energy', copy: 'Long-term investigation into compact power and physical technology.' },
  { phase: 'Integration', title: 'Connected systems', copy: 'Software, analysis, hardware, and verification developed as one architecture.' },
  { phase: 'Growth', title: 'Aldapa Systems', copy: 'A platform for building durable technical capabilities and products.' },
]

export const disciplines = ['Nuclear engineering', 'Mechanical engineering', 'Electrical engineering', 'Software', 'Scientific computing', 'Systems engineering', 'Research']

export const responsibilityAreas = [
  { name: 'Quality', items: ['Reviews', 'Documentation', 'Configuration control', 'Verification'] },
  { name: 'Safety', items: ['Hazard awareness', 'Design review', 'Engineering margins', 'Responsible research'] },
  { name: 'Security', items: ['Software security', 'Infrastructure security', 'IP protection', 'Access control'] },
  { name: 'Traceability', items: ['Requirements', 'Design basis', 'Analysis', 'Changes and results'] },
]

export const referenceGroups = [
  { label: 'Regulatory & safety', entries: [['NRC', 'Regulation and guidance'], ['IAEA', 'International safety standards']] },
  { label: 'Engineering standards', entries: [['ASME', 'Mechanical engineering practice'], ['ANS', 'Nuclear standards'], ['IEEE', 'Electrical and systems practice'], ['ASTM', 'Materials and testing']] },
  { label: 'Measurement & data', entries: [['NIST', 'Measurement science'], ['Evaluated nuclear data', 'Reference datasets']] },
]

export const futureAreas = [
  ['Energy', 'Compact, resilient, long-duration power'],
  ['Software', 'Integrated engineering intelligence'],
  ['Engineering', 'Connected multidisciplinary analysis'],
]
